var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-header-title"},[_vm._v(_vm._s(_vm.$t('components.safes.staffDraws')))]),(
          _vm.$parent.item.stat == 1 &&
          _vm.$site.employeesWithdrawals_allow &&
          (_vm.$user.admin ||
            _vm.$user.role.employees_withdrawals_add)
        )?_c('router-link',{staticClass:"btn btn-sm btn-primary",attrs:{"to":'/employeesWithdrawals/create?safe_id=' + _vm.$route.params.id}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('components.safes.addition'))+" ")]):_vm._e()],1),_c('indexTable',{attrs:{"searchText":_vm.$t('components.safes.searchForAWithdrawal'),"emptyTableText":_vm.$t('employeesWithdrawals.ThereAreNoWithdrawals'),"filter":{safe_id: _vm.$route.params.id},"withoutCard":true,"emptyTableSubText":_vm.$t('allerts.TryAddingSomeItemsToTheTableAndTryAgain'),"cloumns":[
        { column: 'code', title: _vm.$t('components.safes.Withdrawal'), type: 'mainLink', sort: true },
        {column: 'employee_id', title: _vm.$t('employeesWithdrawals.EmployeesName'), to: 'employee', type: 'link', sort: true, link: true },
        {
          column: 'safe_id',
          title: _vm.$t('employeesWithdrawals.Treasury'),
          type: 'link',
          to: 'safe',
          sort: true,
        },
        {
          column: 'date',
          title: _vm.$t('employeesWithdrawals.date'),
          type: 'text',
          sort: true
        },
        {
          column: 'cost',
          title: _vm.$t('employeesWithdrawals.cost'),
          type: 'text',
          sort: true
        },
        {
          column: 'description',
          title: _vm.$t('employeesWithdrawals.thatsAbout'),
          type: 'text',
          sort: true,
        },
        { column: 'notes', title: _vm.$t('employeesWithdrawals.note'), type: 'text', sort: true },

        {
          column: 'options',
          title: _vm.$t('expenses.settings'),
          type: 'options',
          options: [
            { name: 'show' },
            {
              name: 'edit',
              role:
                _vm.$user.admin ||
                _vm.$user.role.expenses_edit,
            },
            { name: 'print', role: true },
            { name: 'download', role: true },
            {
              name: 'delete',
              role:
                _vm.$user.admin ||
                _vm.$user.role.expenses_delete,
            } ],
        } ],"deleteText":{
        attention: _vm.$t('allerts.Attention'),
        areYouReallySureToDeleteTheItem:
          _vm.$t('allerts.areYouReallySureToDeleteTheItem'),
        close: _vm.$t('allerts.close'),
        confirm: _vm.$t('allerts.confirm'),
        loading: _vm.$t('allerts.loading'),
      }}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }